module.exports = __webpack_public_path__ + "img/arrow-right-2.f0a431f8.svg";